import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextWithImage from '@/components/ProductDetailComponents/TextWithImage';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import MultiSellPointsThirdModule from '@/components/ProductDetailComponents/MultiSellPointsModule/Third';
import { EFACCharging, EFCCharging, EFSCharging } from '@/components/UI/svg/ProductStatic';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBasePC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const webpUrl = '/media/rivermax/pc/';
const { EFPic } = createEFPic(webpUrl);

export default function IndexDynamic() {
    const { useRouter, gloproductlist, useLang, Link } = useGlobal();
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('rivermaxportablepowerstation');
    const textWithImgItem1 = {
        title: t('river_max.capacity'),
        synopsis: t('river_max.capacity_sub_title'),
        desc: t('river_max.capacity_desc'),
        img_url: [`rivermax1_${imgSpec}.webp`, `rivermax1_${imgSpec}.jpg`],
    };
    const textWithImgItem2 = {
        title: t('river_max.AC_output'),
        synopsis: t('river_max.AC_output_sub_title'),
        noUseHtmlAttr: false,
        desc: t.rich('river_max.AC_output_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
        img_url: ['rivermax2.webp', 'rivermax2.jpg'],
        arr: [
            { num: '600', eum: 'w', desc: t('river_max.AC_output_desc1') },
            {
                num: locale === 'jp' ? '1200' : '1800',
                eum: 'w',
                desc: t('river_max.AC_output_desc2'),
            },
        ],
    };
    const textWithImgItem3 = {
        title: t('river_max.plus'),
        synopsis: t('river_max.plus_sub_title'),
        desc: t('river_max.plus_desc'),
        img_url: ['rivermax5.webp', 'rivermax5.jpg'],
    };
    const textOnImgItem1 = {
        title: t('river_max.battery_system'),
        synopsis: t('river_max.battery_system_sub_title'),
        desc: t('river_max.battery_system_desc'),
        bgImgs: ['rivermax3.webp', 'rivermax3.jpg'],
    };
    const textOnImgItem2 = {
        title: t('river_max.app_support'),
        synopsis: t('river_max.app_support_sub_title'),
        desc: t('river_max.app_support_desc'),
        bgImgs: [`rivermax4_${appImgLocal}.webp`, `rivermax4_${appImgLocal}.jpg`],
    };
    const sellPoints = [
        {
            icon: <EFACCharging />,
            title: t('river_max.charging_title1'),
            des: t('river_max.charging_desc1'),
            directUrl: '/',
        },
        {
            icon: <EFSCharging />,
            title: t('river_max.charging_title2'),
            des: t('river_max.charging_desc2'),
            directUrl: '/',
        },
        {
            icon: <EFCCharging />,
            title: t('river_max.charging_title3'),
            des: t('river_max.charging_desc3'),
            directUrl: '/',
        },
    ];
    const product: any = {
        us: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        za: ['product_ps_river_river', 'product_ps_river_river_pro_720', 'product_ps_delta_delta_pro'],
    };
    const otherProduct = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);
    const titleFontSize: any = {
        us: 64,
        jp: 48,
        de: 60,
        es: 54,
    };

    const web1Map: any = {
        us: ['RIVER MAX_web2.webp', 'RIVER MAX_web2.png'],
        au: ['RIVER MAX_web2_au.webp', 'RIVER MAX_web2_au.png'],
        uk: ['RIVER MAX_web2_uk.webp', 'RIVER MAX_web2_uk.png'],
        de: ['RIVER MAX_web2_eu.webp', 'RIVER MAX_web2_eu.png'],
        fr: ['RIVER MAX_web2_eu.webp', 'RIVER MAX_web2_eu.png'],
        eu: ['RIVER MAX_web2_eu.webp', 'RIVER MAX_web2_eu.png'],
        it: ['RIVER MAX_web2_eu.webp', 'RIVER MAX_web2_eu.png'],
        es: ['RIVER MAX_web2_eu.webp', 'RIVER MAX_web2_eu.png'],
        cn: ['RIVER MAX_web2_cn.webp', 'RIVER MAX_web2_cn.png'],
        za: ['RIVER MAX_web2_za.webp', 'RIVER MAX_web2_za.png'],
        sa: ['RIVER MAX_web2_uk.webp', 'RIVER MAX_web2_uk.png'],
    };

    return (
        <>
            <LineSpace height="xxl" background="#fff" />
            <div className="section2">
                <div className="top">
                    <div className="tl box">
                        <EFPic
                            name={['RIVER MAX_web1.webp', 'RIVER MAX_web1.png']}
                            alt={t('river_max.image.Capacity')}
                            aria-label={t('river_max.image.Capacity')}
                        />
                        <p className="tit">{t('river_max.image.Capacity')}</p>
                    </div>
                    <div className="tm box">
                        <div className="tmt box">
                            <EFPic
                                name={['RIVER MAX_web5.webp', 'RIVER MAX_web5.png']}
                                alt={t('river_max.image.Charging')}
                                aria-label={t('river_max.image.Charging')}
                            />
                            <p className="tit">{t('river_max.image.Charging')}</p>
                        </div>
                        <div className="tmb box">
                            <EFPic
                                name={['RIVER MAX_web6.webp', 'RIVER MAX_web6.png']}
                                alt={t('river_max.image.Power up to')}
                                aria-label={t('river_max.image.Power up to')}
                            />
                            <div className="tit">
                                {t('river_max.image.Power up to')}
                                <p className="num">{t('river_max.image.10 devices')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="tr box">
                        <EFPic name={web1Map[locale] || web1Map['us']} alt={t('river_max.image.Capacity')} aria-label={t('river_max.image.Capacity')} />
                        <p className="tit t1">{t('river_max.image.Detachable')}</p>
                        <p className="tit t2">{t('river_max.image.Design')}</p>
                    </div>
                </div>
                <div className="bottom">
                    <div className="bl box">
                        <EFPic
                            name={['RIVER MAX_web3.webp', 'RIVER MAX_web3.png']}
                            alt={t('river_max.image.AC Output')}
                            aria-label={t('river_max.image.AC Output')}
                        />
                        <p className="tit">{t('river_max.image.AC Output')}</p>
                        <p className="num">{t('river_max.image.600Wh')}</p>
                    </div>
                    <div className="bm box">
                        <EFPic name={['RIVER MAX_web4.webp', 'RIVER MAX_web4.png']} alt={t('river_max.image.1800W')} aria-label={t('river_max.image.1800W')} />
                        <p className="tit">{t('river_max.image.1800W')}</p>
                    </div>
                    <div className="br box">
                        <EFPic
                            name={['RIVER MAX_web7.webp', 'RIVER MAX_web7.png']}
                            alt={t('river_max.image.App Controls')}
                            aria-label={t('river_max.image.App Controls')}
                        />
                        <p className="tit">{t('river_max.image.App Controls')}</p>
                    </div>
                </div>
            </div>
            <LineSpace height="xl" background="#fff" />
            <div className="text-image text-img1">
                <TextWithImage
                    data={textWithImgItem1}
                    config={{ synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us, webpUrl }}
                />
            </div>
            <div className="text-image text-img2">
                <TextWithImage
                    config={{
                        position: 'right',
                        synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us,
                        isWebp: true,
                        webpUrl,
                        width: (() => {
                            const mapSize = {
                                es: '570px',
                            };
                            type Asmap = keyof typeof mapSize;
                            return mapSize[locale as Asmap] || '550px';
                        })(),
                    }}
                    data={textWithImgItem2}
                />
            </div>
            <LineSpace height={240} background="#fff" />
            <MultiSellPointsThirdModule
                data={{
                    guide: { text: t('river_max.charging') },
                    title: { text: t('river_max.charging_desc') },
                    items: sellPoints,
                    desc: { text: '' },
                }}
                cssStyle={{
                    guideStyle: { color: '#2673ff' },
                    textIconStyle: {
                        wrapperBackColor: '#f6f6f8',
                        wrapperPadding: '40px 50px 0 50px',
                        wrapperHeight: (() => {
                            const mapSize = {
                                es: '440px',
                                de: '440px',
                                fr: '420px',
                            };
                            type Asmapsize = keyof typeof mapSize;
                            return mapSize[locale as Asmapsize] || '400px';
                        })(),
                        wrapperBorderRadius: '20px',
                        iconMargin: (() => {
                            const mapSize = {
                                es: '0 0 20px 0',
                            };
                            type Asmapsize = keyof typeof mapSize;
                            return mapSize[locale as Asmapsize] || '0 0 40px 0';
                        })(),
                        desMargin: (() => {
                            const mapSize = {
                                es: '10px 0 0',
                            };
                            type Asmapsize = keyof typeof mapSize;
                            return mapSize[locale as Asmapsize] || '16px 0 0';
                        })(),
                    },
                }}
            />
            {locale === 'jp' && <div className="SellPointsThird-desc">{t('river_max.charging_desc2_*')}</div>}
            <LineSpace height="xxl" background="#fff" />
            <div className="text-image text-img3" style={{ height: '1080px' }}>
                <TextOnImage
                    config={{
                        position: 'top',
                        titleColor: '#03060b',
                        synopsisColor: '#03060b',
                        descColor: '#03060b',
                        synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us,
                        webpUrl,
                    }}
                    data={textOnImgItem1}
                />
            </div>
            <LineSpace height="xl" background="#fff" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="text-image text-img4">
                    <TextOnImage
                        config={{
                            position: locale == 'sa' ? 'right' : 'left',
                            synopsisFontSize: titleFontSize[locale as keyof typeof titleFontSize] || titleFontSize.us,
                            webpUrl,
                        }}
                        data={textOnImgItem2}
                    />
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height="xl" background="#fff" />
            <section className="RIVER-Max-Plus">
                <div className="textWithImg1">
                    <TextWithImage config={{ position: 'top', synopsisFontSize: locale === 'jp' ? 55 : 64, webpUrl }} data={textWithImgItem3} />
                </div>
                <LineSpace height={270} background="#fff" />
            </section>
            <div className="container">
                <OtherList data={otherProduct} />
            </div>
        </>
    );
}
